import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ThemeContext } from '../../contexts/theme';
import { about } from '../../portfolio';
import { 
  Home, 
  User, 
  Briefcase, 
  PenTool, 
  Image as ImageIcon,
  Moon,
  Sun,
  ExternalLink,
  GraduationCap,
  Award,
  Users,
  Code,
  Heart
} from 'lucide-react';
import TwitterIcon from '@material-ui/icons/Twitter';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';

const Sidebar = ({ isOpen, closeSidebar }) => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext);

  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <NavLink to="/" className="sidebar-logo" onClick={closeSidebar}>
        <div className="sidebar-logo-img">
          <img src="/images/roshandb.jpg" alt={about.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        <span className="sidebar-name">{about.name}</span>
      </NavLink>

      <nav className="sidebar-nav">
        <NavLink to="/" className={({isActive}) => isActive ? 'active' : ''} end onClick={closeSidebar}>
          <Home className="icon" size={16} /> Home
        </NavLink>
        <NavLink to="/about" className={({isActive}) => isActive ? 'active' : ''} onClick={closeSidebar}>
          <User className="icon" size={16} /> About
        </NavLink>
        <NavLink to="/portfolio" className={({isActive}) => isActive ? 'active' : ''}>
          <Briefcase className="icon" size={16} /> Portfolio
        </NavLink>
        <NavLink to="/blogs" className={({isActive}) => isActive ? 'active' : ''}>
          <PenTool className="icon" size={16} /> Writing
        </NavLink>
        <NavLink to="/gallery" className={({isActive}) => isActive ? 'active' : ''}>
          <ImageIcon className="icon" size={16} /> Gallery
        </NavLink>
      </nav>

      <div className="sidebar-section-label">Background</div>
      <nav className="sidebar-nav">
        <NavLink to="/experience" className={({isActive}) => isActive ? 'active' : ''}>
          <Briefcase className="icon" size={16} /> Experience
        </NavLink>
        <NavLink to="/education" className={({isActive}) => isActive ? 'active' : ''}>
          <GraduationCap className="icon" size={16} /> Education
        </NavLink>
        <NavLink to="/certifications" className={({isActive}) => isActive ? 'active' : ''}>
          <Award className="icon" size={16} /> Certifications
        </NavLink>
        <NavLink to="/workshops" className={({isActive}) => isActive ? 'active' : ''}>
          <Users className="icon" size={16} /> Workshops
        </NavLink>
        <NavLink to="/skills" className={({isActive}) => isActive ? 'active' : ''}>
          <Code className="icon" size={16} /> Skills
        </NavLink>
        <NavLink to="/volunteering" className={({isActive}) => isActive ? 'active' : ''}>
          <Heart className="icon" size={16} /> Volunteering
        </NavLink>
      </nav>

      <div className="sidebar-section-label">Projects</div>
      <nav className="sidebar-nav">
        <a href="https://tourmoo.com" target="_blank" rel="noopener noreferrer">
          <span className="sidebar-link-content">Tourmoo</span>
          <ExternalLink className="sidebar-link-external" size={14} />
        </a>
        <a href="https://locomoo.app" target="_blank" rel="noopener noreferrer">
          <span className="sidebar-link-content">Locomoo</span>
          <ExternalLink className="sidebar-link-external" size={14} />
        </a>
      </nav>

      <div className="sidebar-section-label">Online</div>
      <nav className="sidebar-nav">
        {about.social.tweet && <a href={about.social.tweet} target="_blank" rel="noopener noreferrer"><span className="sidebar-link-content"><TwitterIcon className="icon" style={{ fontSize: 16 }} /> X</span> <ExternalLink className="sidebar-link-external" size={14} /></a>}
        {about.social.github && <a href={about.social.github} target="_blank" rel="noopener noreferrer"><span className="sidebar-link-content"><GitHubIcon className="icon" style={{ fontSize: 16 }} /> GitHub</span> <ExternalLink className="sidebar-link-external" size={14} /></a>}
        {about.social.linkedin && <a href={about.social.linkedin} target="_blank" rel="noopener noreferrer"><span className="sidebar-link-content"><LinkedInIcon className="icon" style={{ fontSize: 16 }} /> LinkedIn</span> <ExternalLink className="sidebar-link-external" size={14} /></a>}
        {about.social.instagram && <a href={about.social.instagram} target="_blank" rel="noopener noreferrer"><span className="sidebar-link-content"><InstagramIcon className="icon" style={{ fontSize: 16 }} /> Instagram</span> <ExternalLink className="sidebar-link-external" size={14} /></a>}
      </nav>
    </aside>
  );
};

export default Sidebar;
